<template>
	<!-- CHECK IF COMPONENT IS IN USE -->
	<v-card class="elevation-3 rounded-card pa-1 mb-2" color="white">
		<v-row class="justify-center text-center">
			<v-col cols="1" class="pl-1 pr-5">
				<v-icon large color="primary">location_on</v-icon>
			</v-col>
			<v-col cols="10">
				<v-list-item-group>
					<v-list-item-title
						class="font-weight-bold"
						style="font-family: Montserrat; font-size: 16px; font-style: normal; font-weight: 700; line-height: 20px; letter-spacing: 0em; text-align: left"
						>{{ currentCompany.name }}</v-list-item-title
					>
					<v-list-item-subtitle
						class="pt-1 font-weight-bold"
						style="
							font-family: Montserrat;
							font-size: 14px;
							font-style: normal;
							color: primary;
							font-weight: 500;
							line-height: 15px;
							letter-spacing: 0em;
							text-align: left;
						"
						>{{ currentCompany.address.country }}, {{ currentCompany.address.region }}</v-list-item-subtitle
					>
				</v-list-item-group>
			</v-col>
			<v-col v-if="companies.length > 0" cols="1" class="pl-0 ml-0 pr-2">
				<v-menu offset-y bottom transition="slide-y-transition">
					<template #activator="{ on, attrs }">
						<v-btn v-bind="attrs" small icon color="secondary" v-on="on"><v-icon x-large color="secondary">keyboard_arrow_down</v-icon></v-btn>
					</template>
					<v-card class="pa-3 pt-5 pb-5">
						<v-card v-for="(company, index) in companies" :key="index" @click="setCompany(company)">
							<v-row class="justify-center text-center">
								<v-col cols="12" class="pa-5">
									<v-list-item-group>
										<v-list-item-title
											class="font-weight-bold"
											style="
												font-family: Montserrat;
												font-size: 16px;
												font-style: normal;
												font-weight: 700;
												line-height: 20px;
												letter-spacing: 0em;
												text-align: left;
											"
											>{{ company.name }}</v-list-item-title
										>
										<v-list-item-subtitle
											class="pt-1 font-weight-bold"
											style="
												font-family: Montserrat;
												font-size: 14px;
												font-style: normal;
												color: primary;
												font-weight: 500;
												line-height: 15px;
												letter-spacing: 0em;
												text-align: left;
											"
											>{{ company.address.country }}, {{ company.address.region }}</v-list-item-subtitle
										>
									</v-list-item-group>
								</v-col>
							</v-row>
						</v-card>
					</v-card>
				</v-menu>
			</v-col>
		</v-row>
	</v-card>
</template>

<script>
import store from '@/store';

export default {
	name: 'PracticeDashboardLandingZone',
	components: {},
	data: () => ({}),
	computed: {
		user() {
			return store.getters.user;
		},
		currentCompany() {
			return store.getters.company;
		},

		companies() {
			return store.getters.companies.filter(company => company.id != this.currentCompany.id);
		},
	},
	mounted() {},
	methods: {
		setCompany(comp) {
			store.commit('SET_COMPANY', comp);
		},
	},
};
</script>
